import React from 'react'
import { render } from 'react-dom'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official';


function ActionGraph(props) {
    const options =  {
        chart: {
            type: 'area'
        },
      
        title: {
            text: ''
        },
        subtitle: {
           
        },
        legend: {enabled:false},
        xAxis: {
            categories: props.categories,
            title: {
                text: null
            },
            labels: {
                formatter: function () {
                    return '<b>'+this.value+'</b>'; // clean, unformatted number for year
                }
            },
            
        },
      
        yAxis: {
            title: {
                text: ''
            },
            labels: {
                formatter: function () {
                    return this.value / 1000 + 'k';
                }
            }
        },
        tooltip: {
            labels: {
                formatter: function () {
                    return '<b>'+this.value+'</b>'; // clean, unformatted number for year
                }
            },
        },
        plotOptions: {
            // area: {
            //     //pointStart: 1940,
            //     marker: {
            //         enabled: false,
            //         symbol: 'circle',
            //         radius: 2,
            //         states: {
            //             hover: {
            //                 enabled: true
            //             }
            //         }
            //     },
            //     legend:{

            //     }
            // },
            // series: {
            //     lineColor: '#303030'
            // }
        },
        series: [{
            //name: 'USA',
          ////  color:"red",
            data: props.data
        }]
    }

    return (
        <div>
             <HighchartsReact
                highcharts={Highcharts}
                options={options}
            />
        </div>
    )
}

export default ActionGraph
